module.exports = __webpack_public_path__ + "media/images/cv/screenshot_bbq-d97e1524d2b22b76dea26ae3f482b22a.jpg";